import { create } from 'zustand';

import { ApiUtils } from '@shared/utils';
import { AccountsApi } from '@shared/api/rest';

import { GetTransactionsResponse } from '@shared/api/rest/accounts';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface TransactionsType {
  data: GetTransactionsResponse[];
  loading: boolean;
  error: string | null;
  get: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetTransactionsStore = create<TransactionsType>((set) => ({
  data: [],
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountsApi.getTransactions(id, signal);
      set({ data: result?.data ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
